import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Modal } from 'antd-mobile';
import './index.scss';
export const VDialogText = props => {
	let { show = false, className = 'vdialog-text', title = '标题', comfirmtext = '确认', callback, content = <div>ok</div> } = props;
	let [stateShow, setStateShow] = useState(show);
	function closest(el, selector) {
		const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
		while (el) {
			if (matchesSelector.call(el, selector)) {
				return el;
			}
			el = el.parentElement;
		}
		return null;
	}
	const onWrapTouchStart = e => {
		// fix touch to scroll background page on iOS
		if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
			return;
		}
		const pNode = closest(e.target, '.am-modal-content');
		if (!pNode) {
			e.preventDefault();
		}
	};
	return (
		<Modal
			className={className}
			visible={stateShow}
			transparent
			maskClosable={false}
			onClose={() => {}}
			title={title}
			footer={[
				{
					text: comfirmtext,
					onPress: () => {
						setStateShow(false);
						return callback && callback();
					}
				}
			]}
			wrapProps={{ onTouchStart: onWrapTouchStart }}
			afterClose={() => {
				console.log('afterClose');
			}}>
			{props && props.children}
		</Modal>
	);
};
